<script setup lang="ts">
import GuestLayout from '@/layouts/GuestLayout.vue'
</script>

<template>
  <GuestLayout content-width-class="max-w-5xl">
    <div class="mt-24">
      <slot />
    </div>
  </GuestLayout>
</template>
